import { useQuery } from "@tanstack/react-query";
import { getAllCountries } from "../Services/GetLocation";

export const useCountries = () => {
    return useQuery({
        queryKey: ["countries"],
        queryFn: getAllCountries,
        staleTime: 10 * 60 * 1000, // cache for 10 minutes
    });
};